import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { FilteredOrganizationRules } from "@/Common/Utilities/FilteredOrganizationRules";
import { cacheStore } from "@/Globals/Stores/CacheStore";

interface IUserPracticeInfoComponentProps {
    transitionClass?: string;
    employeeModel: EmployeeUIModel;
}

class UserPracticeInfoComponent extends BaseReactComponent<IUserPracticeInfoComponentProps> {
    private readonly c1Paddingtop: React.CSSProperties = { paddingTop: "5px" };
    private readonly filteredOrganizationRules: FilteredOrganizationRules = new FilteredOrganizationRules(cacheStore.getFilteredOrganizationRulesParam());

    constructor(props: IUserPracticeInfoComponentProps) {
        super(props);

        const activeSite = props.employeeModel?.getActiveSitePrimaryAddress();
        this.filteredOrganizationRules.createLicenceOrganizationRulesByCountryAndState(
            null,
            activeSite?.CountryLookupId,
            activeSite?.StateLookupId
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="user-component" data-cy="userProfile-practiceView">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("PracticeInformationLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered">
                        <div className="tb">
                            {this.renderPractice(this.props.employeeModel)}
                        </div>
                    </div>

                </div>

                <div className="user-component">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("BillingMenuLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered">
                        <div className="tb">
                            {this.renderFacturation(this.props.employeeModel)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderPractice(employee: EmployeeUIModel): JSX.Element {
        return (
            <div className="tbc">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PermitNumberLabel")}</label></td>
                                <td className="c2"><strong>{(employee.Model.Licences && employee.Model.Licences.length > 0) ? (MyleHelper.ReplaceEmptyString(employee.Model.Licences[0].LicenceNumber)) : "--"}</strong></td>
                            </tr>
                            {this.filteredOrganizationRules.envHasLinkedOrgRules && (
                                <tr>
                                    <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("OrganizationLabel")}</label></td>
                                    <td className="c2" data-cy="userProfile-practiceViewOrganization">
                                        <strong>{employee.getIssuingOrgRule()?.OrganisationCode
                                            ? MyleHelper.ReplaceEmptyString(`${employee.getIssuingOrgRule()?.Acronym} - ${employee.getIssuingOrgRule()?.OrganisationName}`)
                                            : "--"
                                        }
                                        </strong>
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("TitleLabel")}</label></td>
                                <td className="c2" data-cy="userProfile-practiceViewTitle"><strong>{MyleHelper.ReplaceEmptyString(LicenceOrganisationRule.getTitleName(employee.getIssuingOrgRule()))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SpecialtyLabel")}</label></td>
                                <td className="c2" data-cy="userProfile-practiceViewSpecialty"><strong>{MyleHelper.ReplaceEmptyString(employee.getSpecialtyString())}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("IssuingUniversityLabel")}</label></td>
                                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.University)}</strong></td>
                            </tr>

                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("StatusLabel")}</label></td>
                                <td className="c2"><strong>{(employee.Model.StatusLookupId) ? (MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.Model.StatusLookupId))) : "--"}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("PermitTypeLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{(employee.Model.Licences && employee.Model.Licences.length > 0) ? (MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.Model.Licences[0].PermitTypeLookupId))) : "--"}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderFacturation(employee: EmployeeUIModel): JSX.Element {
        let billingRows: JSX.Element[];
        switch (employee.getBillingRegionIsoCode()) {
            case "CA-QC":
                billingRows = this.renderQuebecBillingRows(employee);
                break;

            case "CA-BC":
                billingRows = this.renderBCBillingRows(employee);
                break;

            default:
                billingRows = this.renderGenericBillingRows(employee);
                break;
        }

        return (
            <div className="tbc">
                <div>
                    <table>
                        <tbody>
                            {billingRows}
                            {this.canRenderPaymentModeRow(employee) && this.renderPaymentModeRow(employee)}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderQuebecBillingRows(employee: EmployeeUIModel): JSX.Element[] {
        return [
            <tr key="RamqNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("RAMQNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.RamqNumber)}</strong></td>
            </tr>,
            <tr key="RemunerationTypeLookupId">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("RemunerationTypeLabel")}</label></td>
                <td className="c2"><strong>{employee.Model.RemunerationTypeLookupId ? MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.Model.RemunerationTypeLookupId)) : "--"}</strong></td>
            </tr>,
            <tr key="ProfessionalNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("ProfessionalNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.ProfessionalNumber)}</strong></td>
            </tr>,
            <tr key="GroupNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("GroupNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.GroupNumber)}</strong></td>
            </tr>,
            <tr key="DispensationNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("DispensationNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.DispensationNumber)}</strong></td>
            </tr>,
            <tr key="AdministrativeAccountNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("AdministrativeAccountNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.AdministrativeAccountNumber)}</strong></td>
            </tr>,
            <tr key="BillingAgencyNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("BillingAgencyNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.BillingAgencyNumber)}</strong></td>
            </tr>
        ];
    }

    private renderBCBillingRows(employee: EmployeeUIModel): JSX.Element[] {
        return [
            <tr key="ProfessionalNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MspPractitionerNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.ProfessionalNumber)}</strong></td>
            </tr>,
            <tr key="BillingAgencyNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MspPayeeNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.BillingAgencyNumber)}</strong></td>
            </tr>
        ];
    }

    private renderGenericBillingRows(employee: EmployeeUIModel): JSX.Element[] {
        return [
            <tr key="ProfessionalNumber">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("ProfessionalNumberLabel")}</label></td>
                <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.Model.ProfessionalNumber)}</strong></td>
            </tr>
        ];
    }

    private renderPaymentModeRow(employee: EmployeeUIModel): JSX.Element {
        return (
            <tr key="PaymentMode">
                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PaymentModeLabel")}</label></td>
                <td className="c2"><strong>{employee.Model.ExternalBillingPaymentModeLookupId ? (MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.Model.ExternalBillingPaymentModeLookupId))) : "--"}</strong></td>
            </tr>
        );
    }

    private canRenderPaymentModeRow(employee: EmployeeUIModel): boolean {
        return cacheStore.ClinicSettings.EnableExternalBillingPaymentMode &&
            (employee.getIssuingOrgRule()?.StateCode === "BC" ||
                employee.getIssuingOrgRule()?.StateCode === "ON");
    }
}

export { UserPracticeInfoComponent };
